import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserSettings } from '../../../Types';

const initialState: UserSettings = {
    roles: [],
    isAdmin: false,
    isSuperAdmin: false,
    isAvency: false,
    isComplianceAdmin: false,
    isMaintainer: false,
    email: '',
    givenName: '',
    familyName: '',
    image: '',
    accessToken: '',
    expiresAt: 0,
    isLoggedIn: false,
    availableDemoAmount: -1,
    availableDemoAmountFormatted: '',
    userkey: '',
    hasUserPassword: false,
    userPasswordHash: '',
    identifier: '',
    lastChangelogHash: '',
    dsgvoAcceptedAt: 0,
    expertViewEnabled: false,
};

const userSettingsSlice = createSlice({
    name: 'userSettings',
    initialState,
    reducers: {
        setUserSettings: (state, action: PayloadAction<Partial<UserSettings>>) => {
            return { ...state, ...action.payload };
        },
        setUserkey: (state, action: PayloadAction<UserSettings['userkey']>) => {
            state.userkey = action.payload;
        },
        setUserRoles: (state, action: PayloadAction<UserSettings['roles']>) => {
            state.roles = action.payload;
        },
        setUserIsAdmin: (state, action: PayloadAction<UserSettings['isAdmin']>) => {
            state.isAdmin = action.payload;
        },
        setUserIsSuperAdmin: (state, action: PayloadAction<UserSettings['isSuperAdmin']>) => {
            state.isSuperAdmin = action.payload;
        },
        setUserIsAvency: (state, action: PayloadAction<UserSettings['isAvency']>) => {
            state.isAvency = action.payload;
        },
        setUserEmail: (state, action: PayloadAction<UserSettings['email']>) => {
            state.email = action.payload;
        },
        setUserGivenName: (state, action: PayloadAction<UserSettings['givenName']>) => {
            state.givenName = action.payload;
        },
        setUserFamilyName: (state, action: PayloadAction<UserSettings['familyName']>) => {
            state.familyName = action.payload;
        },
        setUserImage: (state, action: PayloadAction<UserSettings['image']>) => {
            state.image = action.payload;
        },
        setUserAccessToken: (state, action: PayloadAction<UserSettings['accessToken']>) => {
            state.accessToken = action.payload;
        },
        setUserExpiresAt: (state, action: PayloadAction<UserSettings['expiresAt']>) => {
            state.expiresAt = action.payload;
        },
        setUserIsLoggedIn: (state, action: PayloadAction<UserSettings['isLoggedIn']>) => {
            state.isLoggedIn = action.payload;
        },
        setUserAvailableDemoAmount: (state, action: PayloadAction<UserSettings['availableDemoAmount']>) => {
            state.availableDemoAmount = action.payload;
        },
        setUserAvailableDemoAmountFormatted: (
            state,
            action: PayloadAction<UserSettings['availableDemoAmountFormatted']>,
        ) => {
            state.availableDemoAmountFormatted = action.payload;
        },
        setLastChangelogHash: (state, action: PayloadAction<UserSettings['lastChangelogHash']>) => {
            state.lastChangelogHash = action.payload;
        },
    },
});

export const {
    setUserSettings,
    setUserkey,
    setUserRoles,
    setUserIsAdmin,
    setUserIsSuperAdmin,
    setUserIsAvency,
    setUserEmail,
    setUserGivenName,
    setUserFamilyName,
    setUserImage,
    setUserAccessToken,
    setUserExpiresAt,
    setUserIsLoggedIn,
    setUserAvailableDemoAmount,
    setUserAvailableDemoAmountFormatted,
    setLastChangelogHash,
} = userSettingsSlice.actions;

export default userSettingsSlice.reducer;
